import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { SearchInputsProperties } from './PortalSearchBar';

// Styles
const s = require('./PortalSearchBarField.css');

// Props
interface IPortalSearchBarFieldProps {
    type?: 'text' | 'password';
    name?: string;
    inputId?: string;
    value: string;
    label?: string;
    icon?: string;
    field: string;
    readOnly?: boolean;
    lightness: 0 | 1 | 2 | 3 | 4;
    isImportant?: boolean;
    isCorrect?: boolean;
    autoFocus?: boolean;
    className?: string;
    onChange?: (field: string, value: any, e: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: (field: string, e: React.MouseEvent<HTMLLabelElement>) => void;
    onFocus?: (field: string, e: React.FocusEvent<HTMLInputElement>) => void;
    onBlur?: (field: string, e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: (field: string, e: React.KeyboardEvent<HTMLInputElement>) => void;
}

// Component
@observer
export class PortalSearchBarField extends React.Component<IPortalSearchBarFieldProps, {}> {
    static get defaultProps(): IPortalSearchBarFieldProps {
        return {
            type: 'text',
            name: null,
            inputId: null,
            value: '',
            label: null,
            icon: null,
            field: '',
            lightness: 1,
            isImportant: false,
            isCorrect: false,
            className: null,
            autoFocus: false,
            readOnly: false,
            onChange: null,
            onClick: null,
            onFocus: null,
            onBlur: null,
            onKeyDown: null
        };
    }

    @observable private isFocused: boolean = false;

    public fieldGroup: HTMLLabelElement = null;
    private referenceFieldGroup = ref => (this.fieldGroup = ref);

    public render() {
        return (
            <label
                onClick={this.handleClick}
                className={classNames(s.fieldGroup, {
                    isImportant: this.props.isImportant,
                    isCorrect: this.props.isCorrect,
                    focused: this.isFocused,
                    hasValue: this.props.value && this.props.value.length > 0,
                    noLabel: this.props.label === null || this.props.label === '',
                    noFill: this.props.lightness <= 0,
                    lighter: this.props.lightness === 2,
                    lightest: this.props.lightness === 3,
                    white: this.props.lightness === 4
                }, this.props.className)}
            >
                {this.props.label && <p title={this.props.label}>{this.props.label}</p>}

                <input
                    autoFocus={this.props.autoFocus}
                    id={this.props.inputId ? this.props.inputId : undefined}
                    name={this.props.name ? this.props.name : undefined}
                    type={this.props.type}
                    title={this.props.value}
                    value={this.props.value}
                    readOnly={this.props.readOnly}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onKeyDown={this.handleKeyDown}
                />

                {this.props.icon && <img className={s.icon} src={this.props.icon} />}
            </label>
        );
    }

    private handleClick = (e: React.MouseEvent<HTMLLabelElement>) => {
        if (this.props.onClick) {
            this.props.onClick(this.props.field, e);
        }
    };

    private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.onChange && !this.props.readOnly) {
            this.props.onChange(this.props.field, e.currentTarget.value, e);
        }
    };

    private handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        this.isFocused = true;

        if (this.props.onFocus) {
            this.props.onFocus(this.props.field, e);
        }
    };

    private handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        this.isFocused = false;

        if (this.props.onBlur) {
            this.props.onBlur(this.props.field, e);
        }
    };

    private handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(this.props.field, e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/PortalSearchBar/PortalSearchBarField.tsx